import { RootState } from "redux/store";

export const selectWeaponData = (state:RootState) => state.weapon;